<template>
  <div class="delivery-block">
    <header>
      <h3>Bestimmungsschlachtbetrieb</h3>
    </header>

    <b-form-group>
      <b-form-radio-group
        v-model="data.slaughterHouseId"
        :options="slaughterHouses"
        :disabled="disabled || saving"
        stacked
      />
      <b-form-radio
        v-model="data.slaughterHouseId"
        label="Anderes"
        :value="null"
        :disabled="disabled || saving">
        Anderes
      </b-form-radio>

      <div v-if="data.slaughterHouseId === null" class="mt-2">
        <b-textarea rows="4" v-model="data.slaughterHouse"/>
      </div>
      <div v-else class="mt-2">
        <b-textarea rows="4" v-model="data.slaughterHouse" disabled/>
      </div>
    </b-form-group>
  </div>
</template>

<script>
import {computed, ref, watch} from '@vue/composition-api'
import ModalSelectFactory from "@/app/components/delivery/ModalSelectFactory.vue";

export default {
  components: {ModalSelectFactory},
  props: {
    value: {type: Object, required: true},
    disabled: {type: Boolean, required: true},
    saving: {type: Boolean, required: true},
  },

  setup(props, {emit}) {
    const store = window.useStore()

    const data = ref(props.value)
    watch(data, () => {
      emit('change', data)
      if (data.value.slaughterHouseId !== null) {
        const slaughterHouse = store.state.pwa.deliveries.piglet.config.slaughterHouse.data.find(d => d.id === data.value.slaughterHouseId);
        data.value.slaughterHouse = [
          slaughterHouse.name,
          `LFBIS: ${slaughterHouse.businessIdentifier.lfbis}`,
          slaughterHouse.street,
          slaughterHouse.town
        ].join('\n')
      }

    }, {deep: true})

    const slaughterHouses = computed(() => {
      return store.state.pwa.deliveries.piglet.config.slaughterHouse.data
        .map(t => ({
          text: t.name,
          value: t.id
        }))
    })

    return {
      data,
      slaughterHouses,
    }
  }
}
</script>
